<template>
  <div>
    <div v-if="type == 'menu'">
      <div
        class="w-full md:w-1/3 lg:w-1/5 p-2"
        v-for="(n, index) in count"
        :key="index + Math.random()"
      >
        <div class="flex flex-col flex-grow">
          <div>
            <span class="skeleton-box h-3 w-1/6 inline-block"></span>
            <span class="skeleton-box h-3 w-1/2 inline-block ml-2"></span>
            <span class="skeleton-box h-3 w-2/4 inline-block"></span>
            <span class="skeleton-box h-3 w-1/3 inline-block ml-2"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 'timeslot'">
      <div
        v-for="(n, index) in count"
        :key="index + Math.random()"
        class="border border-gray-100 rounded-md p-2 m-2 max-w-sm w-full mx-auto"
      >
        <div class="animate-pulse flex space-x-4">
          <div class="flex-1 space-y-4 px-8 py-1 justify-center items-center">
            <div class="h-4 bg-gray-200 rounded w-full"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: "menu",
    },
    count: {
      type: Number,
      required: false,
      default: 5,
    },
  },
};
</script>
<style>
@use postcss-preset-env;
@use postcss-nested-ancestors;
@use postcss-nested;

.skeleton-box {
  position: relative;
  overflow: hidden;
  background-color: #eff3f7;
}
.skeleton-box::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 3s infinite;
  content: "";
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
